module.exports = __webpack_public_path__ + "img/Jarviz-edit.7bcc31b2.png";